<script setup>
import { defineProps, defineEmits } from 'vue'
const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])
</script>

<template>
<v-card variant="tonal">
	<v-card-text class="pb-2">
		{{ field.label }}
	</v-card-text>
	<v-card-text
		class="mt-0 pt-0"
	>
		<v-btn-toggle
			:model-value="modelValue"
			:mandatory="!field.clearable"
			:variant="(modelValue !== undefined) ? 'elevated' : 'outlined'"
			:divided="!modelValue"
			class="d-flex"
			@update:model-value="(val) => emit('update:modelValue', val)"
		>
			<v-btn 
				v-for="option in field.options"
				:key="option.value"
				v-ripple="false"
				:value="option.value" 
				:color="option.color"
				class="flex-grow-1"
				:variant="modelValue === option.value ? 'elevated' : 'tonal'"
			>
				{{ option.label }}
			</v-btn>
		</v-btn-toggle>
	</v-card-text>
</v-card>
</template>

<style lang="scss" scoped>

</style>